export default {
  methods: {
    removerAcentos(text) {
      text = text.replace(new RegExp('[ÁÀÂÃÄ]', 'gi'), 'a');
      text = text.replace(new RegExp('[ÉÈÊẼË]', 'gi'), 'e');
      text = text.replace(new RegExp('[ÍÌÎĨÏ]', 'gi'), 'i');
      text = text.replace(new RegExp('[ÓÒÔÕÖ]', 'gi'), 'o');
      text = text.replace(new RegExp('[ÚÙÛŨÜ]', 'gi'), 'u');
      text = text.replace(new RegExp('[ÇĈ]', 'gi'), 'c');
      return text;
    },
  }
}



// WEBPACK FOOTER //
// ./src/mixins/removerAcentos.js